import { isApp } from '../others/devices'

import { getAnalytics } from './global.analytics'

export const removeAnalyticsScript = () => {
  if (!isApp()) {
    getAnalytics()?.reset?.()
  }
  const scriptToRemove = document.getElementById('analytics-script')
  if (scriptToRemove) {
    document.body.removeChild(scriptToRemove)
  }
}
